import {
  getAllResources,
  getResource,
  filterPage,
  selectSite,
} from "../../selectors";
import FancyClothesProvider from "../FancyClothesProvider";
import Footer from "../Footer";
import { IsReadOnlyContext } from "../IsReadOnlyContext";
import WebsiteHeader from "../WebsiteHeader";
import WebsitePages from "../WebsitePages";
import OnlineInvitationRSVPButton from "./OnlineInvitationRSVPButton";
import { css } from "@emotion/react";
import {
  GlobalStyles,
  theme,
  useMediaQueryState,
} from "@minted/minted-components";
import React from "react";
import { connect } from "react-redux";

const stickyButtonPadding = css`
  margin-bottom: ${theme.spacing.x8};
`;

const OnlineInvitationSite = ({
  event,
  pages,
  resources,
  site,
  themeAuthor,
}) => {
  const mediumMediaQueryState = useMediaQueryState({
    mediaQuerySize: "medium",
  });

  const isMobile = mediumMediaQueryState === "BELOW";
  const filteredPages = pages.filter((page) =>
    filterPage(page, {
      ...resources,
      sites: [site],
    }),
  );

  return (
    <FancyClothesProvider>
      <GlobalStyles />
      <div id="home">
        <WebsiteHeader condensed={false} pages={filteredPages} />
      </div>
      <IsReadOnlyContext.Provider value={Boolean(site.isDemoSite)}>
        <WebsitePages pages={filteredPages} resources={resources} site={site} />
      </IsReadOnlyContext.Provider>
      <OnlineInvitationRSVPButton event={event} site={site} />
      <Footer artist={themeAuthor} />
      {isMobile && <div css={stickyButtonPadding} />}
    </FancyClothesProvider>
  );
};
const mapStateToProps = (state) => {
  const site = selectSite(state.resources.sites);

  const pages = getResource(state.resources.pages);
  const events = getResource(state.resources.events);
  const resources = getAllResources(state.resources);

  return {
    event: events[0],
    pages,
    resources,
    site,
    themeAuthor: state.theme.attribution,
  };
};

export default connect(mapStateToProps)(OnlineInvitationSite);
